import { I18n } from 'i18n-js';

const i18n = new I18n();

i18n.defaultLocale = 'en';
i18n.locale = document.documentElement.lang;

const translations = window.translations || '';
delete window.translations;

i18n.store(translations);

export default i18n;
